import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SystemDetails } from '@twaice-fe/shared/models';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { BehaviorSubject } from 'rxjs';
import { SystemLiveKpisService } from './system-live-kpis.service';

@Component({
  selector: 'twaice-fe-system-live-kpis',
  templateUrl: './system-live-kpis.component.html',
  styleUrls: ['./system-live-kpis.component.scss'],
  standalone: true,
  imports: [AsyncPipe, NzSpinModule],
  providers: [SystemLiveKpisService],
})
export class SystemLiveKpisComponent implements OnInit, OnChanges {
  @Input() system$: BehaviorSubject<SystemDetails | null>;
  @Input() visible = false;

  readonly kpiState$ = this.liveKpisService.kpiState$;

  constructor(private liveKpisService: SystemLiveKpisService) {}

  ngOnInit(): void {
    this.liveKpisService.connect(this.system$, () => this.visible);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']) {
      this.liveKpisService.onVisibilityChange(this.visible);
    }
  }
}
